import { render, staticRenderFns } from "./aitutorSaveList.vue?vue&type=template&id=e8d3f4f4&"
import script from "./aitutorSaveList.vue?vue&type=script&lang=js&"
export * from "./aitutorSaveList.vue?vue&type=script&lang=js&"
import style0 from "./aitutorSaveList.vue?vue&type=style&index=0&id=e8d3f4f4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports